import { registerLocaleData } from '@angular/common';
import {
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeEn from '@angular/common/locales/fr';
import localeId from '@angular/common/locales/id';
import {
  APP_ID,
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { provideClientHydration, withEventReplay, withIncrementalHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, TitleStrategy } from '@angular/router';
import { routes } from '@banyan/app.routes';
import { authInitializer } from '@banyan/commons/initializers/auth.initializer';
import { authInterceptor } from '@banyan/commons/interceptors/auth.interceptor';
import { errorServerInterceptor } from '@banyan/commons/interceptors/error-server.interceptor';
import { loaderInterceptor } from '@banyan/commons/interceptors/loader.interceptor';
import { localeInterceptor } from '@banyan/commons/interceptors/locale.interceptor';
import { CustomTitleStrategy } from '@banyan/commons/services/custom-title-strategy.service';
import { MatIconRegistryService } from '@banyan/commons/services/mat-icon-registry.service';
import { environment } from '@env/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideOAuthClient } from 'angular-oauth2-oidc';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

registerLocaleData(localeEn);
registerLocaleData(localeId);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptorsFromDi(), withInterceptors([
      loaderInterceptor,
      authInterceptor,
      localeInterceptor,
      errorServerInterceptor,
    ])),
    provideAnimations(),
    { provide: 'googleTagManagerId', useValue: environment.googleTagManagerId },
    { provide: 'googleTagManagerAuth', useValue: environment.gtmAuth },
    { provide: 'googleTagManagerPreview', useValue: environment.gtmPreview },
    provideOAuthClient({
      resourceServer: {
        allowedUrls: environment.allowedUrls,
        sendAccessToken: true,
        customUrlValidation: (url) => url.includes(environment.middlewareUrl),
      },
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        useDefaultLang: false,
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideAppInitializer(authInitializer()),
    { provide: APP_ID, useValue: 'serverApp' },
    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategy,
    },
    MatIconRegistry,
    MatIconRegistryService,
  ],
};